<div [ngClass]="isInWizard ? 'tableWizard' : 'table'">
    <table class="tableStyles mat-table-sort-mod" mat-table matSort [dataSource]="table.data">
        <ng-container [matColumnDef]="col" *ngFor="let col of table.displayedColumns">
            <th [class]="table.styles.headerCol" mat-header-cell *matHeaderCellDef mat-sort-header #header [sortActionDescription]="'Sort by ' + col"
                [class.dark-color-header]="table.styles.isDarkTheme" [style.font-size.px]="headerFontSize" [style.color]="headerColor" (click)="headerClick()">
                <div class="col-name-container">{{ 'dashboard:' + col | i18next }}</div>
                <div style="margin-left: 10px">
                  <i class="fad fa-sort" [class.fa-sort-down]="isSortArrowShown(col, 'desc')" [class.fa-sort-up]="isSortArrowShown(col, 'asc')"></i>
                </div>
            </th>
            <td [class]="table.styles.rowCol" [style.font-size.px]="rowFontSize" [style.color]="rowColor" mat-cell *matCellDef="let element">
              <span *ngIf="col=='StatusDetails' && element[col].toString().slice(-2) == ' +'" class="tdValue">{{ element[col].slice(0, -2)}} <span class="red-plus">+</span></span>
              <span *ngIf="!(col=='StatusDetails' && element[col].toString().slice(-2) == ' +')" class="tdValue">{{element[col] ? element[col] : 0}}</span>
                <i *ngIf="col === 'Name' && element['AlarmFlag'] === 1" class="fas fa-exclamation-triangle labelAlarm"
                    [tooltip]="HtmlContent" [options]="tooltipOptions" (mouseenter)="showAlarm(element)"></i>
            </td>
        </ng-container>
        <ng-template #HtmlContent>
            <div class="popoverContentContainer" *ngIf="alarmProps.length === 1">
                <div *ngFor="let alarm of alarmProps">
                    <div class="popoverTitle"><span class="titleText"><i class="fal fa-bell"></i> Alarm for:
                            {{alarmTitle}}</span></div>
                    <div class="popoverContent">
                        <span class="contentText">
                            {{ 'dashboard:Alarm Name' | i18next }}: {{alarm['alarmName']}}
                        </span>
                    </div>
                    <div class="popoverContent">
                        <span class="contentText">
                            {{ 'dashboard:Basic Queue' | i18next }}: {{alarm['basicQueue']}}
                        </span>
                    </div>
                    <div class="popoverContent">
                        <span class="contentText">
                            {{ 'dashboard:Threshold Type' | i18next }}: {{alarm['thresholdTypeName']}}
                        </span>
                    </div>
                    <div class="popoverContent">
                        <span class="contentText">
                            {{ 'dashboard:Alarm Time' | i18next }}: {{alarm['alarmTime']}}
                        </span>
                    </div>
                </div>
            </div>
            <div *ngIf="alarmProps.length > 1">
                <div class="popoverTitleInline"><span class="titleText">
                        <i class="fal fa-bell"></i> Alarm for: {{alarmTitle}}</span>
                </div>
                <div class="popoverContentContainerInline">
                    <table class="alarmTable">
                        <tr>
                            <th class="alarmTh">{{ 'dashboard:Alarm Name' | i18next }}</th>
                            <th class="alarmTh">{{ 'dashboard:Basic Queue' | i18next }}</th>
                            <th class="alarmTh">{{ 'dashboard:Threshold Type' | i18next }}</th>
                            <th class="alarmTh">{{ 'dashboard:Alarm Time' | i18next }}</th>
                        </tr>
                        <tr *ngFor="let alarm of alarmProps">
                            <td class="alarmTd">
                                {{alarm['alarmName']}}
                            </td>
                            <td class="alarmTd">
                                {{alarm['basicQueue']}}
                            </td>
                            <td class="alarmTd">
                                {{alarm['thresholdTypeName']}}
                            </td>
                            <td class="alarmTd">
                                {{alarm['alarmTime']}}
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
        </ng-template>
        <tr [ngClass]="table.styles.header" mat-header-row *matHeaderRowDef="table.displayedColumns"></tr>
        <tr *matRowDef="let row; columns: table.displayedColumns; let i = index" [ngClass]="getRowClass(row, i , table)" mat-row ></tr>
    </table>
</div>
